import React, { useEffect, useState } from "react";
import { backend, categoryurl } from "../../../path";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../../App.css";
import styled from "styled-components";
import { GrFacebookOption } from "react-icons/gr";
import { LiaInstagram, LiaUserCircle } from "react-icons/lia";
import { AiFillYoutube } from "react-icons/ai";
import { RiTwitterXLine } from "react-icons/ri";
import { GoHome } from "react-icons/go";
import { MdOutlineCategory } from "react-icons/md";
import { PiShoppingCartThin } from "react-icons/pi";
import {
  IoCloseOutline,
  IoPersonOutline,
  IoSearchOutline,
} from "react-icons/io5";
import { CiHeart, CiLogin } from "react-icons/ci";

import { RxDashboard, RxHamburgerMenu } from "react-icons/rx";
import { BsChevronDown } from "react-icons/bs";
import LogInOut from "../../components/icons/LogInOut";
import CartOwn from "../../components/icons/CartOwn";
import Login from "../../pages/registration/login";
import Registration from "../../pages/registration/registration";

function HeaderMainNew(props) {
  const navigate = useNavigate();
  const [subcategory, setSubcategory] = useState(false);
  const [subcategoryItems, setSubcategoryItems] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [data, setData] = useState([]);
  const [name, setName] = useState([]);
  const [products, setProducts] = useState([]);
  const [cartData, setCartData] = useState([]);
  const [wish, setWish] = useState([]);
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [search, setSearch] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isMobileHeaderActive, setMobileHeaderActive] = useState(false);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [isCategoriesVisible, setCategoriesVisible] = useState(false);
  const [openLoginDropdown, setOpenLoginDropdown] = useState(false);
  const [openSearch, setOpenSearch] = useState();
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );
  const location = useLocation();
  const [isLogin, setIsLogin] = useState(false);

  // Function to toggle the visibility of the mobile header
  const toggleMobileHeader = () => {
    setMobileHeaderActive(!isMobileHeaderActive);
  };

  useEffect(() => {
    setMobileHeaderActive(false);
    setOpenLoginDropdown(false);
    setCategoriesVisible(false);
  }, [location]);
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  const fetchData = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(backend + "getcategorywithsubcategory", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchProducts = () => {
    setLoading(true);

    fetch(backend + "getallproductsfrontend", {
      method: "GET",
    })
      .then((response) => {
        if (response.status === 302) {
          const redirectUrl = response.headers.get("Location");
          console.error(`Redirecting to: ${redirectUrl}`);
          throw new Error(`Redirection to ${redirectUrl}`);
        }
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setProducts(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    fetchProducts();
  }, [selectedCategory]);

  const handleSubCategory = (id) => {
    const selectedCategory = data.find((item) => item.category_id === id);
    if (selectedCategory) {
      setSubcategoryItems(selectedCategory.subcategory || []);
    }
    setSubcategory(true);
    setSelectedCategory(id);
  };

  const handleSubCategoryRoute = (subCategoryId) => {
    // sessionStorage.setItem("subCategoryId", subCategoryId);
    toggleDropdown();
    props?.SearchFetch();
    navigate(`/subcategory/${subCategoryId}`);
    // window.location.reload();
  };

  const handleCategoryMain = (cat) => {
    // sessionStorage.setItem("categoryId", cat);
    // setSubcategory(false)
    props?.SearchFetch();
    navigate(`/category/${cat}`);
    // window.location.reload();
  };

  useEffect(() => {
    if (authenticated) {
      fetchDataCart();
      fetchDataWish();
    }
  }, [authenticated, props.cartChange, props.wishChange]);

  const fetchDataCart = () => {
    setLoading(true);

    fetch(backend + `getcartbyuseriduserside`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCartData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchDataWish = () => {
    setLoading(true);

    fetch(backend + `getwishlistbyuseriduserside`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setWish(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchName = () => {
    setLoading(true);

    const url = authenticated?.usertype === 1 ? "getusername" : "getadminname";

    fetch(backend + url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setName(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (authenticated) {
      fetchName();
    }
  }, [authenticated]);

  const [openCategory, setOpenCategory] = useState(null);

  // Function to handle category click
  const handleCategoryClick = (categoryId) => {
    // Toggle the category: if already open, close it; if closed, open it
    setOpenCategory(openCategory === categoryId ? null : categoryId);
  };

  const getOptions = (inputValue) => {
    setSearch(inputValue);
    if (inputValue.trim() === "") {
      setFilteredOptions([]);
      return;
    }

    // Filter products based on input value
    const filtered = products.filter((product) =>
      product.product_name.toLowerCase().includes(inputValue.toLowerCase())
    );
    setFilteredOptions(filtered.slice(0, 18));
  };
  const handleSelectSearch = (inputValue) => {
    props.setSearch(inputValue);
    setFilteredOptions([]);
  };

  const handleProductRoute = (productId) => {
    setSearch("");
    props.setSearch("");
    setFilteredOptions([]);
    navigate(`/product/${productId}`);
  };
  const handleOpenLoginDropDown = () => {
    setOpenLoginDropdown(!openLoginDropdown);
  };
  const handleOpenCategory = () => {
    setCategoriesVisible(!isCategoriesVisible);
  };
  return (
    <>
      {authenticated?.usertype === 1 ? (
        <>
          <Header>
            <Main>
              <div className="wrapper">
                <Container>
                  <Link to="/">
                    <ImageContainer>
                      <img src="/storage/general/ks-logo32.png" />
                    </ImageContainer>
                  </Link>
                  <Nav>
                    <NavInner>
                      <Link to="/">Today's Deals</Link>
                      <Link to="/">Popular Products</Link>
                      <Link to="/">Top Selling</Link>
                    </NavInner>
                    <SearchContainer>
                      {/* <IoSearchOutline
                        style={{ fontSize: "30px", color: "#200E32" }}
                      /> */}
                      <img
                        src="/storage/general/Vector.svg"
                        alt="search-icon"
                      />
                      <Input
                        type="text"
                        id="search"
                        className="px-2"
                        placeholder="Search"
                        // value={props.search}
                        value={search}
                        onChange={(e) => getOptions(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSelectSearch(search);
                          }
                        }} // onChange={(e) => props.setSearch(e.target.value)}
                        autocomplete="off"
                      />
                      {filteredOptions.length > 0 && (
                        <SearchSuggestions>
                          {filteredOptions.map((option, index) => (
                            <Suggestion
                              key={index}
                              onClick={() =>
                                handleProductRoute(option?.product_slug)
                              }
                            >
                              {option.product_name}
                            </Suggestion>
                          ))}
                        </SearchSuggestions>
                      )}
                    </SearchContainer>
                  </Nav>
                  <Section className="top-btns">
                    <Buttons>
                      {/* <Button className="notification-style">
                        {wish && wish.length > 0 ? (
                          <Number>{wish.length}</Number>
                        ) : null}
                        <div>
                          <span>
                            <CiHeart />
                          </span>
                          <Link to={authenticated ? "/wishlist" : "/login"}>
                            Wishlist
                          </Link>
                        </div>
                      </Button> */}
                      <Button className="notification-style">
                        {cartData && cartData.length > 0 ? (
                          <Number>{cartData.length}</Number>
                        ) : null}
                        <div>
                          <div className="d-flex justify-content-between w-100">
                            <CartOwn />

                            <Link
                              to={authenticated ? "/cart" : "/login"}
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                marginLeft: "5px",
                                fontFamily: "Inter, sans-serif",
                              }}
                            >
                              Cart
                            </Link>
                          </div>
                        </div>
                      </Button>
                      {authenticated ? (
                        <Button
                          className="user"
                          onClick={handleOpenLoginDropDown}
                        >
                          <span>
                            <IoPersonOutline />
                          </span>
                          <div>
                            <div
                              // to="#"
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                marginLeft: "5px",
                                fontFamily: "Inter, sans-serif",
                              }}
                              // onClick={()=>handleOpenLoginDropDown}
                            >
                              {" "}
                              {authenticated && `${name}`}
                            </div>
                          </div>
                        </Button>
                      ) : (
                        <Button
                          onClick={handleOpenLoginDropDown}
                          className=" d-flex items-center gap-1"
                          // style={{fontSize:'18px', fontWeight:'500'}}
                        >
                          {/* <CiLogin />  */}
                          <LogInOut />
                          <div class="font-Inter font-bold text-lg leading-none tracking-normal text-black">
                            Login/Signup
                          </div>
                        </Button>
                      )}

                      {authenticated ? (
                        <LogoutModal open={openLoginDropdown}>
                          <div className="flex flex-col space-y-4 p-4 border border-bg-[rgba(200, 200, 200, 1)] bg-white rounded-[21px] shadow-md font-JostSans">
                            <Link
                              to="/myorders"
                              onClick={() => props?.SearchFetch()}
                            >
                              <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                                <svg
                                  className="w-5 h-5 mr-2"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                    clipRule="evenodd"
                                  ></path>
                                </svg>
                                My Orders
                              </button>
                            </Link>
                            <div onClick={handleLogout}>
                              <Link to="/" onClick={() => props?.SearchFetch()}>
                                <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                                  <svg
                                    className="w-5 h-5 mr-2"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                                      clipRule="evenodd"
                                    ></path>
                                  </svg>
                                  Logout
                                </button>
                              </Link>
                            </div>
                          </div>
                        </LogoutModal>
                      ) : (
                        <LogoutModal open={openLoginDropdown}>
                          <div className="flex flex-col space-y-4 pe-3 ps-2 py-3 bg-white border border-bg-[rgba(200, 200, 200, 1)] rounded-[21px] shadow-md font-JostSans">
                            {/* <Link
                              to="/login"
                              onClick={() => props?.SearchFetch()}
                            > */}
                            <button
                              command="show-modal"
                              commandfor="dialog"
                              onClick={() => setIsLogin(true)}
                              className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="15"
                                viewBox="0 0 12 15"
                                fill="none"
                                className="mr-4 mt-1"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M5.25 0C4.65326 0 4.08097 0.237053 3.65901 0.65901C3.23705 1.08097 3 1.65326 3 2.25V12.75C3 13.3467 3.23705 13.919 3.65901 14.341C4.08097 14.7629 4.65326 15 5.25 15H9.75C10.3467 15 10.919 14.7629 11.341 14.341C11.7629 13.919 12 13.3467 12 12.75V2.25C12 1.65326 11.7629 1.08097 11.341 0.65901C10.919 0.237053 10.3467 0 9.75 0H5.25ZM6.21975 4.71975C6.3604 4.57915 6.55113 4.50016 6.75 4.50016C6.94887 4.50016 7.1396 4.57915 7.28025 4.71975L9.53025 6.96975C9.67085 7.1104 9.74984 7.30113 9.74984 7.5C9.74984 7.69887 9.67085 7.8896 9.53025 8.03025L7.28025 10.2802C7.1388 10.4169 6.94935 10.4925 6.7527 10.4908C6.55605 10.489 6.36794 10.4102 6.22889 10.2711C6.08983 10.1321 6.01095 9.94395 6.00924 9.7473C6.00754 9.55065 6.08313 9.3612 6.21975 9.21975L7.1895 8.25H0.75C0.551088 8.25 0.360322 8.17098 0.21967 8.03033C0.0790178 7.88968 0 7.69891 0 7.5C0 7.30109 0.0790178 7.11032 0.21967 6.96967C0.360322 6.82902 0.551088 6.75 0.75 6.75H7.1895L6.21975 5.78025C6.07915 5.6396 6.00016 5.44887 6.00016 5.25C6.00016 5.05113 6.07915 4.8604 6.21975 4.71975Z"
                                  fill="black"
                                />
                              </svg>
                              Login
                            </button>
                            {/* </Link> */}
                            <button
                              command="show-modal"
                              commandfor="dialog"
                              onClick={() => setIsLogin(false)}
                              className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="13"
                                height="15"
                                viewBox="0 0 13 15"
                                fill="none"
                                className="mr-4 mt-1"
                              >
                                <path
                                  d="M11.4051 1.22204C11.206 1.02276 10.9695 0.864685 10.7091 0.756857C10.4488 0.649029 10.1698 0.593562 9.88808 0.593628C9.60633 0.593694 9.32735 0.649291 9.0671 0.75724C8.80684 0.86519 8.57042 1.02337 8.37134 1.22275L1.63721 7.96609C1.23596 8.36826 1.01053 8.91311 1.01034 9.48121L1.01034 11.75C1.01034 12.0433 1.24834 12.2813 1.54159 12.2813H3.82454C4.39334 12.2813 4.93875 12.0546 5.34038 11.653L12.0695 4.91955C12.4709 4.51719 12.6964 3.97205 12.6964 3.40371C12.6964 2.83537 12.4709 2.29023 12.0695 1.88788L11.4051 1.22204ZM0.833252 13.3438C0.692356 13.3438 0.55723 13.3997 0.457601 13.4994C0.357973 13.599 0.302002 13.7341 0.302002 13.875C0.302002 14.0159 0.357973 14.151 0.457601 14.2507C0.55723 14.3503 0.692356 14.4063 0.833252 14.4063H12.1666C12.3075 14.4063 12.4426 14.3503 12.5422 14.2507C12.6419 14.151 12.6978 14.0159 12.6978 13.875C12.6978 13.7341 12.6419 13.599 12.5422 13.4994C12.4426 13.3997 12.3075 13.3438 12.1666 13.3438H0.833252Z"
                                  fill="#1D1B20"
                                />
                              </svg>
                              Register
                            </button>
                          </div>
                        </LogoutModal>
                      )}
                    </Buttons>
                  </Section>
                </Container>
              </div>
            </Main>
            <ItemContainer>
              <Items>
                {data.map((item, i) => (
                  <Item
                    // style={{
                    //   backgroundColor:
                    //     selectedCategory === item.category_id && subcategory
                    //       ? "#e1f0da"
                    //       : "transparent",
                    // }}
                    key={i}
                    onMouseEnter={() => handleSubCategory(item.category_id)}
                    // onClick={() => setSubcategory(false)}
                    onClick={() => {
                      handleCategoryMain(item.category_slug);
                    }}
                  >
                    <ItemDiv>
                      <Link
                        to=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#000",
                          fontSize: "15px",
                        }}
                      >
                        <div>
                          <img
                            src={categoryurl + item.logo}
                            width={30}
                            height={30}
                          />{" "}
                        </div>
                        <div>{item.category_name}</div>
                      </Link>
                      <Arrow>
                        <BsChevronDown />
                      </Arrow>
                    </ItemDiv>
                    {subcategory && (
                      <Dropdown className="ml-3">
                        {subcategoryItems.length > 0 ? (
                          subcategoryItems.map((subItem, index) => (
                            <li key={index}>
                              <div
                                // to={`/subcategory/${subItem.sub_category_id}`}
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent bubbling to parent
                                  handleSubCategoryRoute(
                                    subItem.sub_category_slug
                                  );
                                }}
                                // to={"/product-list"}
                              >
                                {subItem.sub_category_name}
                              </div>
                            </li>
                          ))
                        ) : (
                          <ul className="ml-3">
                            <li>coming soon</li>
                          </ul>
                        )}
                      </Dropdown>
                    )}
                  </Item>
                ))}
              </Items>
            </ItemContainer>
          </Header>
          {/* mobile container */}
          <MobileHeader>
            <div className="flex justify-start">
              <RxHamburgerMenu
                onClick={toggleMobileHeader}
                style={{ fontSize: "26px", color: "#123524", cursor: "pointer" }}
              />
            </div>

            <div className="flex justify-center">
              <Link to="/">
                <ImageContainer>
                  <img src="/storage/general/ks-logo32.png" />
                </ImageContainer>
              </Link>
            </div>

            <div className="flex justify-end">
              {authenticated ? (
                <Button className="user" onClick={handleOpenLoginDropDown} data-login-dropdown="true">
                  <IoPersonOutline style={{ fontSize: "22px", color: "#123524" }} />
                  <span className="ml-1 text-xs font-semibold text-kerala-green">{authenticated && `${name}`}</span>
                </Button>
              ) : (
                <MobileLoginButton onClick={handleOpenLoginDropDown} data-login-dropdown="true">
                  Login/Signup
                </MobileLoginButton>
              )}
            </div>
            {authenticated ? (
              <LogoutModalMobileSec open={openLoginDropdown}>
                <div className="flex flex-col space-y-4 p-4 border border-bg-[rgba(200, 200, 200, 1)] bg-white rounded-[21px] shadow-md font-JostSans">
                  <Link to="/myorders" onClick={() => props?.SearchFetch()}>
                    <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                      <svg
                        className="w-5 h-5 mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      My Orders
                    </button>
                  </Link>
                  <div onClick={handleLogout}>
                    <Link to="/" onClick={() => props?.SearchFetch()}>
                      <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                        <svg
                          className="w-5 h-5 mr-2"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                        Logout
                      </button>
                    </Link>
                  </div>
                </div>
              </LogoutModalMobileSec>
            ) : (
              <LogoutModalMobileSec open={openLoginDropdown}>
                <div className="flex flex-col space-y-4 pe-3 ps-2 py-3 bg-white border border-bg-[rgba(200, 200, 200, 1)] rounded-[21px] shadow-md font-JostSans">
                  {/* <Link
                              to="/login"
                              onClick={() => props?.SearchFetch()}
                            > */}
                  <button
                    command="show-modal"
                    commandfor="dialog"
                    onClick={() => setIsLogin(true)}
                    className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="15"
                      viewBox="0 0 12 15"
                      fill="none"
                      className="mr-4 mt-1"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.25 0C4.65326 0 4.08097 0.237053 3.65901 0.65901C3.23705 1.08097 3 1.65326 3 2.25V12.75C3 13.3467 3.23705 13.919 3.65901 14.341C4.08097 14.7629 4.65326 15 5.25 15H9.75C10.3467 15 10.919 14.7629 11.341 14.341C11.7629 13.919 12 13.3467 12 12.75V2.25C12 1.65326 11.7629 1.08097 11.341 0.65901C10.919 0.237053 10.3467 0 9.75 0H5.25ZM6.21975 4.71975C6.3604 4.57915 6.55113 4.50016 6.75 4.50016C6.94887 4.50016 7.1396 4.57915 7.28025 4.71975L9.53025 6.96975C9.67085 7.1104 9.74984 7.30113 9.74984 7.5C9.74984 7.69887 9.67085 7.8896 9.53025 8.03025L7.28025 10.2802C7.1388 10.4169 6.94935 10.4925 6.7527 10.4908C6.55605 10.489 6.36794 10.4102 6.22889 10.2711C6.08983 10.1321 6.01095 9.94395 6.00924 9.7473C6.00754 9.55065 6.08313 9.3612 6.21975 9.21975L7.1895 8.25H0.75C0.551088 8.25 0.360322 8.17098 0.21967 8.03033C0.0790178 7.88968 0 7.69891 0 7.5C0 7.30109 0.0790178 7.11032 0.21967 6.96967C0.360322 6.82902 0.551088 6.75 0.75 6.75H7.1895L6.21975 5.78025C6.07915 5.6396 6.00016 5.44887 6.00016 5.25C6.00016 5.05113 6.07915 4.8604 6.21975 4.71975Z"
                        fill="black"
                      />
                    </svg>
                    Login
                  </button>
                  {/* </Link> */}
                  <button
                    command="show-modal"
                    commandfor="dialog"
                    onClick={() => setIsLogin(false)}
                    className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="15"
                      viewBox="0 0 13 15"
                      fill="none"
                      className="mr-4 mt-1"
                    >
                      <path
                        d="M11.4051 1.22204C11.206 1.02276 10.9695 0.864685 10.7091 0.756857C10.4488 0.649029 10.1698 0.593562 9.88808 0.593628C9.60633 0.593694 9.32735 0.649291 9.0671 0.75724C8.80684 0.86519 8.57042 1.02337 8.37134 1.22275L1.63721 7.96609C1.23596 8.36826 1.01053 8.91311 1.01034 9.48121L1.01034 11.75C1.01034 12.0433 1.24834 12.2813 1.54159 12.2813H3.82454C4.39334 12.2813 4.93875 12.0546 5.34038 11.653L12.0695 4.91955C12.4709 4.51719 12.6964 3.97205 12.6964 3.40371C12.6964 2.83537 12.4709 2.29023 12.0695 1.88788L11.4051 1.22204ZM0.833252 13.3438C0.692356 13.3438 0.55723 13.3997 0.457601 13.4994C0.357973 13.599 0.302002 13.7341 0.302002 13.875C0.302002 14.0159 0.357973 14.151 0.457601 14.2507C0.55723 14.3503 0.692356 14.4063 0.833252 14.4063H12.1666C12.3075 14.4063 12.4426 14.3503 12.5422 14.2507C12.6419 14.151 12.6978 14.0159 12.6978 13.875C12.6978 13.7341 12.6419 13.599 12.5422 13.4994C12.4426 13.3997 12.3075 13.3438 12.1666 13.3438H0.833252Z"
                        fill="#1D1B20"
                      />
                    </svg>
                    Register
                  </button>
                </div>
              </LogoutModalMobileSec>
            )}
          </MobileHeader>
          <MobileHeaderSearch>
            <SearchContainerOld className="">
              <Input
                // className="mobile-search px-2"
                type="text"
                placeholder="Search"
                // value={props.search}
                value={search}
                onChange={(e) => getOptions(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSelectSearch(search);
                  }
                }} // onChange={(e) => props.setSearch(e.target.value)}
                autocomplete="off"
              />
              {/* <IoSearchOutline /> */}
              <img src="/storage/general/Vector.svg" alt="search-icon" />
              {filteredOptions.length > 0 && (
                <SearchSuggestions className="mobile">
                  {filteredOptions.map((option, index) => (
                    <Suggestion
                      key={index}
                      onClick={() => handleProductRoute(option?.product_slug)}
                    >
                      {option.product_name}
                    </Suggestion>
                  ))}
                </SearchSuggestions>
              )}
            </SearchContainerOld>
          </MobileHeaderSearch>
          <Slider className={isMobileHeaderActive ? "active" : ""}>
            <MobileTop>
              <Link to="/">
                <ImageContainer>
                  <img src="/storage/general/ks-logo32.png" />
                </ImageContainer>
              </Link>
              <div onClick={toggleMobileHeader}>
                <IoCloseOutline />
              </div>
            </MobileTop>
            <Socials className="mobile">
              <a
                target="_blank"
                href="https://www.facebook.com/myKeralaspecial?mibextid=qi2Omg&rdid=kccxW9NpVX3BFzrU&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FXM1oRDDkvagcQKW9%2F%3Fmibextid%3Dqi2Omg"
              >
                <GrFacebookOption />
              </a>
              <a
                target="_blank"
                href="https://www.instagram.com/keralaspecial/"
              >
                <LiaInstagram />
              </a>
              <a
                target="_blank"
                href="https://www.youtube.com/@keralaspecial5256"
              >
                <AiFillYoutube />
              </a>
              <a
                target="_blank"
                href="https://x.com/mykeralaspecial?t=5jaIdWgLfUhVzxywcQto9g"
              >
                <RiTwitterXLine />
              </a>
            </Socials>
            <Buttons className="mobile">
              {!authenticated ? (
                <div className="">
                  {/* <Link to="/login" onClick={() => props?.SearchFetch()}>
                    {" "}
                    <button className="">LOGIN</button>
                  </Link>
                  <Link to="/register">
                    <button className="">REGISTER</button>
                  </Link> */}
                </div>
              ) : (
                <>
                  <div className="">
                    <Link to="/myorders" onClick={() => props?.SearchFetch()}>
                      {" "}
                      <button className="">MY ORDERS</button>
                    </Link>
                  </div>
                  <div className="" onClick={handleLogout}>
                    <Link to="/" onClick={() => props?.SearchFetch()}>
                      {" "}
                      <button className="">LOGOUT</button>
                    </Link>
                  </div>
                </>
              )}
              {/* <LoginBtn>
                <Link to="/login">Login</Link>
              </LoginBtn>
              <LoginBtn>
                <Link to="/register">Register</Link>
              </LoginBtn> */}
            </Buttons>
            <Nav className="mobile">
              <Link to="/">Home</Link>
              <Link to="/about-us">About Us</Link>
              <Link to="/blog">Blogs</Link>
              <Link to="/contact-us">Contact Us</Link>
            </Nav>
            <P>Copyright</P>
          </Slider>
          <MobileHeaderBottom>
            <div className="w-full flex justify-between items-center px-2">
              <Link to="/" className="flex flex-col items-center justify-center flex-1 py-1 text-kerala-green hover:text-kerala-gold transition-colors">
                <GoHome style={{ fontSize: "24px" }} />
                <span className="text-[10px] font-semibold font-jost mt-1 uppercase tracking-wider">Home</span>
              </Link>
              <button onClick={handleOpenCategory} className="flex flex-col items-center justify-center flex-1 py-1 text-kerala-green hover:text-kerala-gold transition-colors border-none bg-transparent outline-none">
                <MdOutlineCategory style={{ fontSize: "24px" }} />
                <span className="text-[10px] font-semibold font-jost mt-1 uppercase tracking-wider">Categories</span>
              </button>
              <Link
                to={authenticated ? "/wishlist" : "#"}
                onClick={(e) => {
                  if (!authenticated) {
                    e.preventDefault();
                    setIsLogin(true);
                    const dlg = document.getElementById("dialog");
                    if (dlg && typeof dlg.showModal === "function") {
                      dlg.showModal();
                    }
                  }
                }}
                className="flex flex-col items-center justify-center flex-1 py-1 text-kerala-green hover:text-kerala-gold transition-colors relative"
              >
                {wish && wish.length > 0 && (
                  <span className="absolute top-0 right-4 bg-kerala-green text-white text-[9px] font-bold h-4 w-4 rounded-full flex items-center justify-center border border-white">
                    {wish.length}
                  </span>
                )}
                <CiHeart style={{ fontSize: "24px" }} />
                <span className="text-[10px] font-semibold font-jost mt-1 uppercase tracking-wider">Wishlist</span>
              </Link>
              <Link
                to={authenticated ? "/cart" : "#"}
                onClick={(e) => {
                  if (!authenticated) {
                    e.preventDefault();
                    setIsLogin(true);
                    const dlg = document.getElementById("dialog");
                    if (dlg && typeof dlg.showModal === "function") {
                      dlg.showModal();
                    }
                  }
                }}
                className="flex flex-col items-center justify-center flex-1 py-1 text-kerala-green hover:text-kerala-gold transition-colors relative"
              >
                {cartData && cartData.length > 0 && (
                  <span className="absolute top-0 right-4 bg-kerala-green text-white text-[9px] font-bold h-4 w-4 rounded-full flex items-center justify-center border border-white">
                    {cartData.length}
                  </span>
                )}
                <PiShoppingCartThin style={{ fontSize: "24px" }} />
                <span className="text-[10px] font-semibold font-jost mt-1 uppercase tracking-wider">Cart</span>
              </Link>
              <CategoriesModal className={isCategoriesVisible ? "active" : ""}>
                <Items className="mobile">
                  {data.slice(0, -1).map((item, i) => (
                    <Item
                      key={i}
                      onClick={() => {
                        handleCategoryMain(item.category_slug);
                      }}
                    >
                      <ItemDiv>
                        <>
                          <div>
                            <img
                              src={categoryurl + item.logo}
                              width={30}
                              height={30}
                            />{" "}
                          </div>
                          <div>{item.category_name}</div>
                        </>
                      </ItemDiv>
                    </Item>
                  ))}
                </Items>
              </CategoriesModal>
            </div>
          </MobileHeaderBottom>
          <MobileHeaderBottomBackground></MobileHeaderBottomBackground>
        </>
      ) : authenticated?.usertype === 0 ? (
        <div className="header-middle header-middle-ptb-1 d-none d-lg-block fixed-top bg-light">
          <div className="container">
            <div className="header-wrap">
              <Link to="/" style={{ padding: "10px 0" }}>
                <ImageContainer>
                  <img src="/storage/general/ks-logo32.png" />
                </ImageContainer>
              </Link>

              <div className="d-flex justify-content-end w-100">
                <div className="header-action-right">
                  <div className="header-action-2">
                    {/* <div className="header-action-icon-2">
                            <Link to="/onamgift">
                              <span className="lable">
                                <button
                                  type="button"
                                  className="hover-up"
                                  style={{
                                    backgroundColor: '#3bb77e',
                                    color: '#fff',
                                    borderRadius: '5px',
                                    border: '1px solid',
                                    height: '36px',
                                    width: '100px',
                                    bottom: '5px',
                                    animation: 'blink 1s infinite'
                                  }}                          >
                                  ONAM GIFTS
                                </button></span>
                            </Link>
                          </div> */}
                    {/* <div className="header-action-icon-2">
                      <Link to="/wishlist">
                        <img
                          className="svgInject"
                          alt="Wishlist"
                          src="/themes/nest/imgs/theme/icons/icon-heart.svg"
                        />
                        <span className="pro-count blue wishlist-count">
                          {wish?.length}
                        </span>
                      </Link>
                      <Link to="/wishlist">
                        <span className="lable">Wishlist</span>
                      </Link>
                    </div>
                    <div className="header-action-icon-2">
                      <Link className="mini-cart-icon" to="/cart">
                        <img
                          alt="Cart"
                          src="/themes/nest/imgs/theme/icons/icon-cart.svg"
                        />
                        <span className="pro-count blue">
                          {cartData?.length}
                        </span>
                      </Link>
                      <Link to="/cart">
                        <span className="lable">Cart</span>
                      </Link>
                      {cartData?.length < 1 && (
                        <div className="cart-dropdown-wrap cart-dropdown-hm2 cart-dropdown-panel">
                          <span>No products in the cart.</span>
                        </div>
                      )}
                    </div> */}
                    <div className="header-action-icon-2">
                      <Link>
                        <img
                          className="svgInject rounded-circle"
                          alt="Account"
                          src="/themes/nest/imgs/theme/icons/icon-user.svg"
                        />
                      </Link>
                      <Link to="/" onClick={() => props?.SearchFetch()}>
                        <span className="lable me-1">
                          {authenticated ? `${name}` : "Account"}
                        </span>
                      </Link>
                      <div className="cart-dropdown-wrap cart-dropdown-hm2 account-dropdown">
                        <ul>
                          {!authenticated ? (
                            <>
                              <div className="btn-wrap">
                                <Link
                                  to="/login"
                                  onClick={() => props?.SearchFetch()}
                                >
                                  {" "}
                                  <button className="login-btn">LOGIN</button>
                                </Link>
                                <Link to="/register">
                                  <button className="login-btn">
                                    REGISTER
                                  </button>
                                </Link>
                              </div>
                            </>
                          ) : (
                            <div className="btn-wrap" onClick={handleLogout}>
                              <Link to="/" onClick={() => props?.SearchFetch()}>
                                {" "}
                                <button className="login-btn">LOGOUT</button>
                              </Link>
                            </div>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : authenticated?.usertype === null ? (
        <div className="header-middle header-middle-ptb-1 d-none d-lg-block fixed-top bg-light">
          <div className="container">
            <div className="header-wrap">
              <div className="logo logo-width-1">
                <Link to="/" onClick={() => props?.SearchFetch()}>
                  <img
                    src="/storage/general/ks-logo32.png"
                    alt="Kerala Specials-Logo"
                  />
                </Link>
              </div>
              <div className="d-flex justify-content-end w-100">
                <div className="header-action-right">
                  <div className="header-action-2">
                    {/* <div className="header-action-icon-2">
                            <Link to="/onamgift">
                              <span className="lable">
                                <button
                                  type="button"
                                  className="hover-up"
                                  style={{
                                    backgroundColor: '#3bb77e',
                                    color: '#fff',
                                    borderRadius: '5px',
                                    border: '1px solid',
                                    height: '36px',
                                    width: '100px',
                                    bottom: '5px',
                                    animation: 'blink 1s infinite'
                                  }}                          >
                                  ONAM GIFTS
                                </button></span>
                            </Link>
                          </div> */}
                    {/* <div className="header-action-icon-2">
                      <Link to="/wishlist">
                        <img
                          className="svgInject"
                          alt="Wishlist"
                          src="/themes/nest/imgs/theme/icons/icon-heart.svg"
                        />
                        <span className="pro-count blue wishlist-count">
                          0{" "}
                        </span>
                      </Link>
                      <Link to="/wishlist">
                        <span className="lable">Wishlist</span>
                      </Link>
                    </div> */}
                    <div className="header-action-icon-2">
                      <Link className="mini-cart-icon" to="/cart">
                        <img
                          alt="Cart"
                          src="/themes/nest/imgs/theme/icons/icon-cart.svg"
                        />
                        <span className="pro-count blue">
                          {cartData?.length}
                        </span>
                      </Link>
                      <Link to="/cart">
                        <span className="lable">Cart</span>
                      </Link>
                      {cartData?.length < 1 && (
                        <div className="cart-dropdown-wrap cart-dropdown-hm2 cart-dropdown-panel">
                          <span>No products in the cart.</span>
                        </div>
                      )}
                    </div>
                    <div className="header-action-icon-2">
                      <div
                        onClick={() => setIsLogin(true)}
                        style={{cursor: 'pointer'}}
                      >
                        <img
                          className="svgInject rounded-circle"
                          alt="Account"
                          src="/themes/nest/imgs/theme/icons/icon-user.svg"
                        />
                      </div>
                      <Link to="/" onClick={() => props?.SearchFetch()}>
                        <span className="lable me-1">
                          {authenticated ? `${name}` : <CiLogin />}
                        </span>
                      </Link>
                      <div className="cart-dropdown-wrap cart-dropdown-hm2 account-dropdown">
                        <ul>
                          {!authenticated ? (
                            <>
                              <div className="btn-wrap">
                                <Link
                                  to="/login"
                                  onClick={() => props?.SearchFetch()}
                                >
                                  {" "}
                                  <button className="login-btn">LOGIN</button>
                                </Link>
                                <Link to="/register">
                                  <button className="login-btn">
                                    REGISTER
                                  </button>
                                </Link>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="btn-wrap" onClick={handleLogout}>
                                <Link
                                  to="/"
                                  onClick={() => props?.SearchFetch()}
                                >
                                  {" "}
                                  <button className="login-btn">LOGOUT</button>
                                </Link>
                              </div>
                            </>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <Header>
            {/* <Top>
              <Left>
                <Socials>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/myKeralaspecial?mibextid=qi2Omg&rdid=kccxW9NpVX3BFzrU&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FXM1oRDDkvagcQKW9%2F%3Fmibextid%3Dqi2Omg"
                  >
                    <GrFacebookOption />
                  </a>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/keralaspecial/"
                  >
                    <LiaInstagram />
                  </a>
                  <a
                    target="_blank"
                    href="https://www.youtube.com/@keralaspecial5256"
                  >
                    <AiFillYoutube />
                  </a>
                  <a
                    target="_blank"
                    href="https://x.com/mykeralaspecial?t=5jaIdWgLfUhVzxywcQto9g"
                  >
                    <RiTwitterXLine />
                  </a>
                </Socials>
              </Left>
              <Right>
                <a href="tel:+917356629493">+ 91 735 6629 493</a>
              </Right>
            </Top> */}
            <Main>
              <div className="wrapper">
                <Container>
                  <Link to="/">
                    <ImageContainer>
                      <img src="/storage/general/ks-logo32.png" />
                    </ImageContainer>
                  </Link>
                  <Nav>
                    <NavInner>
                      <Link to="/">Today's Deals</Link>
                      <Link to="/">Popular Products</Link>
                      <Link to="/">Top Selling</Link>
                    </NavInner>
                    <SearchContainer>
                      {/* <IoSearchOutline
                        style={{ fontSize: "30px", color: "#200E32" }}
                      /> */}
                      <img
                        src="/storage/general/Vector.svg"
                        alt="search-icon"
                      />
                      <Input
                        type="text"
                        id="search"
                        className="px-2"
                        placeholder="Search"
                        // value={props.search}
                        value={search}
                        onChange={(e) => getOptions(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSelectSearch(search);
                          }
                        }} // onChange={(e) => props.setSearch(e.target.value)}
                        autocomplete="off"
                      />
                      {filteredOptions.length > 0 && (
                        <SearchSuggestions>
                          {filteredOptions.map((option, index) => (
                            <Suggestion
                              key={index}
                              onClick={() =>
                                handleProductRoute(option?.product_slug)
                              }
                            >
                              {option.product_name}
                            </Suggestion>
                          ))}
                        </SearchSuggestions>
                      )}
                    </SearchContainer>
                  </Nav>
                  <Section className="top-btns">
                    <Buttons>
                      {/* <Button className="notification-style">
                        {wish && wish.length > 0 ? (
                          <Number>{wish.length}</Number>
                        ) : null}
                        <div>
                          <span>
                            <CiHeart />
                          </span>
                          <Link to={authenticated ? "/wishlist" : "/login"}>
                            Wishlist
                          </Link>
                        </div>
                      </Button> */}
                      <Button className="notification-style">
                        {cartData && cartData.length > 0 ? (
                          <Number>{cartData.length}</Number>
                        ) : null}
                        <div>
                          <div className="d-flex justify-content-between w-100">
                            <CartOwn />

                            <Link
                              to={authenticated ? "/wishlist" : "/login"}
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                marginLeft: "5px",
                                fontFamily: "Inter, sans-serif",
                              }}
                            >
                              Cart
                            </Link>
                          </div>
                        </div>
                      </Button>
                      {authenticated ? (
                        <Button
                          className="user"
                          onClick={handleOpenLoginDropDown}
                        >
                          <span>
                            <IoPersonOutline />
                          </span>
                          <div>
                            <Link to="/" onClick={() => props?.SearchFetch()}>
                              {" "}
                              {authenticated && `${name}`}
                            </Link>
                          </div>
                        </Button>
                      ) : (
                        <Button
                          onClick={handleOpenLoginDropDown}
                          className=" d-flex items-center gap-1"
                          // style={{fontSize:'18px', fontWeight:'500'}}
                        >
                          {/* <CiLogin />  */}
                          <LogInOut />
                          <div class="font-Inter font-bold text-lg leading-none tracking-normal text-black">
                            Login/Signup
                          </div>
                        </Button>
                      )}

                      {authenticated ? (
                        <LogoutModal open={openLoginDropdown}>
                          <div className="flex flex-col space-y-4 p-4 border border-bg-[rgba(200, 200, 200, 1)] bg-white rounded-[21px] shadow-md font-JostSans">
                            <Link
                              to="/myorders"
                              onClick={() => props?.SearchFetch()}
                            >
                              <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                                <svg
                                  className="w-5 h-5 mr-2"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                    clipRule="evenodd"
                                  ></path>
                                </svg>
                                My Orders
                              </button>
                            </Link>
                            <div onClick={handleLogout}>
                              <Link to="/" onClick={() => props?.SearchFetch()}>
                                <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                                  <svg
                                    className="w-5 h-5 mr-2"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                                      clipRule="evenodd"
                                    ></path>
                                  </svg>
                                  Logout
                                </button>
                              </Link>
                            </div>
                          </div>
                        </LogoutModal>
                      ) : (
                        <LogoutModal open={openLoginDropdown}>
                          <div className="flex flex-col space-y-4 pe-3 ps-2 py-3 bg-white border border-bg-[rgba(200, 200, 200, 1)] rounded-[21px] shadow-md font-JostSans">
                            {/* <Link
                              to="/login"
                              onClick={() => props?.SearchFetch()}
                            > */}
                            <button
                              command="show-modal"
                              commandfor="dialog"
                              onClick={() => setIsLogin(true)}
                              className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="15"
                                viewBox="0 0 12 15"
                                fill="none"
                                className="mr-4 mt-1"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M5.25 0C4.65326 0 4.08097 0.237053 3.65901 0.65901C3.23705 1.08097 3 1.65326 3 2.25V12.75C3 13.3467 3.23705 13.919 3.65901 14.341C4.08097 14.7629 4.65326 15 5.25 15H9.75C10.3467 15 10.919 14.7629 11.341 14.341C11.7629 13.919 12 13.3467 12 12.75V2.25C12 1.65326 11.7629 1.08097 11.341 0.65901C10.919 0.237053 10.3467 0 9.75 0H5.25ZM6.21975 4.71975C6.3604 4.57915 6.55113 4.50016 6.75 4.50016C6.94887 4.50016 7.1396 4.57915 7.28025 4.71975L9.53025 6.96975C9.67085 7.1104 9.74984 7.30113 9.74984 7.5C9.74984 7.69887 9.67085 7.8896 9.53025 8.03025L7.28025 10.2802C7.1388 10.4169 6.94935 10.4925 6.7527 10.4908C6.55605 10.489 6.36794 10.4102 6.22889 10.2711C6.08983 10.1321 6.01095 9.94395 6.00924 9.7473C6.00754 9.55065 6.08313 9.3612 6.21975 9.21975L7.1895 8.25H0.75C0.551088 8.25 0.360322 8.17098 0.21967 8.03033C0.0790178 7.88968 0 7.69891 0 7.5C0 7.30109 0.0790178 7.11032 0.21967 6.96967C0.360322 6.82902 0.551088 6.75 0.75 6.75H7.1895L6.21975 5.78025C6.07915 5.6396 6.00016 5.44887 6.00016 5.25C6.00016 5.05113 6.07915 4.8604 6.21975 4.71975Z"
                                  fill="black"
                                />
                              </svg>
                              Login
                            </button>
                            {/* </Link> */}
                            <button
                              command="show-modal"
                              commandfor="dialog"
                              onClick={() => setIsLogin(false)}
                              className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="13"
                                height="15"
                                viewBox="0 0 13 15"
                                fill="none"
                                className="mr-4 mt-1"
                              >
                                <path
                                  d="M11.4051 1.22204C11.206 1.02276 10.9695 0.864685 10.7091 0.756857C10.4488 0.649029 10.1698 0.593562 9.88808 0.593628C9.60633 0.593694 9.32735 0.649291 9.0671 0.75724C8.80684 0.86519 8.57042 1.02337 8.37134 1.22275L1.63721 7.96609C1.23596 8.36826 1.01053 8.91311 1.01034 9.48121L1.01034 11.75C1.01034 12.0433 1.24834 12.2813 1.54159 12.2813H3.82454C4.39334 12.2813 4.93875 12.0546 5.34038 11.653L12.0695 4.91955C12.4709 4.51719 12.6964 3.97205 12.6964 3.40371C12.6964 2.83537 12.4709 2.29023 12.0695 1.88788L11.4051 1.22204ZM0.833252 13.3438C0.692356 13.3438 0.55723 13.3997 0.457601 13.4994C0.357973 13.599 0.302002 13.7341 0.302002 13.875C0.302002 14.0159 0.357973 14.151 0.457601 14.2507C0.55723 14.3503 0.692356 14.4063 0.833252 14.4063H12.1666C12.3075 14.4063 12.4426 14.3503 12.5422 14.2507C12.6419 14.151 12.6978 14.0159 12.6978 13.875C12.6978 13.7341 12.6419 13.599 12.5422 13.4994C12.4426 13.3997 12.3075 13.3438 12.1666 13.3438H0.833252Z"
                                  fill="#1D1B20"
                                />
                              </svg>
                              Register
                            </button>
                          </div>
                        </LogoutModal>
                      )}
                    </Buttons>
                  </Section>
                </Container>
              </div>
            </Main>
            <ItemContainer>
              <Items>
                {data.map((item, i) => (
                  <Item
                    // style={{
                    //   backgroundColor:
                    //     selectedCategory === item.category_id && subcategory
                    //       ? "#e1f0da"
                    //       : "transparent",
                    // }}
                    key={i}
                    onMouseEnter={() => handleSubCategory(item.category_id)}
                    // onClick={() => setSubcategory(false)}
                    onClick={() => {
                      handleCategoryMain(item.category_slug);
                    }}
                  >
                    <ItemDiv>
                      <Link
                        to=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#000",
                          fontSize: "15px",
                        }}
                      >
                        <div>
                          <img
                            src={categoryurl + item.logo}
                            width={30}
                            height={30}
                          />{" "}
                        </div>
                        <div>{item.category_name}</div>
                      </Link>
                      <Arrow>
                        <BsChevronDown />
                      </Arrow>
                    </ItemDiv>
                    {subcategory && (
                      <Dropdown className="ml-3">
                        {subcategoryItems.length > 0 ? (
                          subcategoryItems.map((subItem, index) => (
                            <li key={index}>
                              <div
                                // to={`/subcategory/${subItem.sub_category_id}`}

                                // to={"/product-list"}
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent bubbling to parent
                                  handleSubCategoryRoute(
                                    subItem.sub_category_slug
                                  );
                                }}
                              >
                                {subItem.sub_category_name}
                              </div>
                            </li>
                          ))
                        ) : (
                          <ul className="ml-3">
                            <li>coming soon</li>
                          </ul>
                        )}
                      </Dropdown>
                    )}
                  </Item>
                ))}
              </Items>
            </ItemContainer>
          </Header>
          {/* mobile container */}
          <MobileHeader>
            <div className="flex justify-start">
              <RxHamburgerMenu
                onClick={toggleMobileHeader}
                style={{ fontSize: "26px", color: "#123524", cursor: "pointer" }}
              />
            </div>

            <div className="flex justify-center">
              <Link to="/">
                <ImageContainer>
                  <img src="/storage/general/ks-logo32.png" />
                </ImageContainer>
              </Link>
            </div>

            <div className="flex justify-end">
              {authenticated ? (
                <Button className="user" onClick={handleOpenLoginDropDown} data-login-dropdown="true">
                  <IoPersonOutline style={{ fontSize: "22px", color: "#123524" }} />
                  <span className="ml-1 text-xs font-semibold text-kerala-green">{authenticated && `${name}`}</span>
                </Button>
              ) : (
                <MobileLoginButton onClick={handleOpenLoginDropDown} data-login-dropdown="true">
                  Login/Signup
                </MobileLoginButton>
              )}
            </div>
            {authenticated ? (
              <LogoutModalMobileSec open={openLoginDropdown}>
                <div className="flex flex-col space-y-4 p-4 border border-bg-[rgba(200, 200, 200, 1)] bg-white rounded-[21px] shadow-md font-JostSans">
                  <Link to="/myorders" onClick={() => props?.SearchFetch()}>
                    <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                      <svg
                        className="w-5 h-5 mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      My Orders
                    </button>
                  </Link>
                  <div onClick={handleLogout}>
                    <Link to="/" onClick={() => props?.SearchFetch()}>
                      <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                        <svg
                          className="w-5 h-5 mr-2"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                        Logout
                      </button>
                    </Link>
                  </div>
                </div>
              </LogoutModalMobileSec>
            ) : (
              <LogoutModalMobileSec open={openLoginDropdown}>
                <div className="flex flex-col space-y-4 pe-3 ps-2 py-3 bg-white border border-bg-[rgba(200, 200, 200, 1)] rounded-[21px] shadow-md font-JostSans">
                  {/* <Link
                              to="/login"
                              onClick={() => props?.SearchFetch()}
                            > */}
                  <button
                    command="show-modal"
                    commandfor="dialog"
                    onClick={() => setIsLogin(true)}
                    className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="15"
                      viewBox="0 0 12 15"
                      fill="none"
                      className="mr-4 mt-1"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.25 0C4.65326 0 4.08097 0.237053 3.65901 0.65901C3.23705 1.08097 3 1.65326 3 2.25V12.75C3 13.3467 3.23705 13.919 3.65901 14.341C4.08097 14.7629 4.65326 15 5.25 15H9.75C10.3467 15 10.919 14.7629 11.341 14.341C11.7629 13.919 12 13.3467 12 12.75V2.25C12 1.65326 11.7629 1.08097 11.341 0.65901C10.919 0.237053 10.3467 0 9.75 0H5.25ZM6.21975 4.71975C6.3604 4.57915 6.55113 4.50016 6.75 4.50016C6.94887 4.50016 7.1396 4.57915 7.28025 4.71975L9.53025 6.96975C9.67085 7.1104 9.74984 7.30113 9.74984 7.5C9.74984 7.69887 9.67085 7.8896 9.53025 8.03025L7.28025 10.2802C7.1388 10.4169 6.94935 10.4925 6.7527 10.4908C6.55605 10.489 6.36794 10.4102 6.22889 10.2711C6.08983 10.1321 6.01095 9.94395 6.00924 9.7473C6.00754 9.55065 6.08313 9.3612 6.21975 9.21975L7.1895 8.25H0.75C0.551088 8.25 0.360322 8.17098 0.21967 8.03033C0.0790178 7.88968 0 7.69891 0 7.5C0 7.30109 0.0790178 7.11032 0.21967 6.96967C0.360322 6.82902 0.551088 6.75 0.75 6.75H7.1895L6.21975 5.78025C6.07915 5.6396 6.00016 5.44887 6.00016 5.25C6.00016 5.05113 6.07915 4.8604 6.21975 4.71975Z"
                        fill="black"
                      />
                    </svg>
                    Login
                  </button>
                  {/* </Link> */}
                  <button
                    command="show-modal"
                    commandfor="dialog"
                    onClick={() => setIsLogin(false)}
                    className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="15"
                      viewBox="0 0 13 15"
                      fill="none"
                      className="mr-4 mt-1"
                    >
                      <path
                        d="M11.4051 1.22204C11.206 1.02276 10.9695 0.864685 10.7091 0.756857C10.4488 0.649029 10.1698 0.593562 9.88808 0.593628C9.60633 0.593694 9.32735 0.649291 9.0671 0.75724C8.80684 0.86519 8.57042 1.02337 8.37134 1.22275L1.63721 7.96609C1.23596 8.36826 1.01053 8.91311 1.01034 9.48121L1.01034 11.75C1.01034 12.0433 1.24834 12.2813 1.54159 12.2813H3.82454C4.39334 12.2813 4.93875 12.0546 5.34038 11.653L12.0695 4.91955C12.4709 4.51719 12.6964 3.97205 12.6964 3.40371C12.6964 2.83537 12.4709 2.29023 12.0695 1.88788L11.4051 1.22204ZM0.833252 13.3438C0.692356 13.3438 0.55723 13.3997 0.457601 13.4994C0.357973 13.599 0.302002 13.7341 0.302002 13.875C0.302002 14.0159 0.357973 14.151 0.457601 14.2507C0.55723 14.3503 0.692356 14.4063 0.833252 14.4063H12.1666C12.3075 14.4063 12.4426 14.3503 12.5422 14.2507C12.6419 14.151 12.6978 14.0159 12.6978 13.875C12.6978 13.7341 12.6419 13.599 12.5422 13.4994C12.4426 13.3997 12.3075 13.3438 12.1666 13.3438H0.833252Z"
                        fill="#1D1B20"
                      />
                    </svg>
                    Register
                  </button>
                </div>
              </LogoutModalMobileSec>
            )}
          </MobileHeader>
          <MobileHeaderSearch>
            <SearchContainerOld className="">
              <Input
                // className="mobile-search px-2"
                type="text"
                placeholder="Search"
                // value={props.search}
                value={search}
                onChange={(e) => getOptions(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSelectSearch(search);
                  }
                }} // onChange={(e) => props.setSearch(e.target.value)}
                autocomplete="off"
              />
              {/* <IoSearchOutline /> */}
              <img src="/storage/general/Vector.svg" alt="search-icon" />
              {filteredOptions.length > 0 && (
                <SearchSuggestions className="mobile">
                  {filteredOptions.map((option, index) => (
                    <Suggestion
                      key={index}
                      onClick={() => handleProductRoute(option?.product_slug)}
                    >
                      {option.product_name}
                    </Suggestion>
                  ))}
                </SearchSuggestions>
              )}
            </SearchContainerOld>
          </MobileHeaderSearch>
          <Slider className={isMobileHeaderActive ? "active" : ""}>
            <MobileTop>
              <Link to="/">
                <ImageContainer>
                  <img src="/storage/general/ks-logo32.png" />
                </ImageContainer>
              </Link>
              <div onClick={toggleMobileHeader}>
                <IoCloseOutline />
              </div>
            </MobileTop>
            <Socials className="mobile">
              <a
                target="_blank"
                href="https://www.facebook.com/myKeralaspecial?mibextid=qi2Omg&rdid=kccxW9NpVX3BFzrU&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FXM1oRDDkvagcQKW9%2F%3Fmibextid%3Dqi2Omg"
              >
                <GrFacebookOption />
              </a>
              <a
                target="_blank"
                href="https://www.instagram.com/keralaspecial/"
              >
                <LiaInstagram />
              </a>
              <a
                target="_blank"
                href="https://www.youtube.com/@keralaspecial5256"
              >
                <AiFillYoutube />
              </a>
              <a
                target="_blank"
                href="https://x.com/mykeralaspecial?t=5jaIdWgLfUhVzxywcQto9g"
              >
                <RiTwitterXLine />
              </a>
            </Socials>
            <Buttons className="mobile">
              {!authenticated ? (
                <>
                  {/* <Link to="/login" onClick={() => props?.SearchFetch()}>
                    {" "}
                    <button className="">LOGIN</button>
                  </Link>
                  <Link to="/register">
                    <button className="">REGISTER</button>
                  </Link> */}
                </>
              ) : (
                <>
                  <div className="">
                    <Link to="/myorders" onClick={() => props?.SearchFetch()}>
                      {" "}
                      <button className="">MY ORDERS</button>
                    </Link>
                  </div>
                  <div className="" onClick={handleLogout}>
                    <Link to="/" onClick={() => props?.SearchFetch()}>
                      {" "}
                      <button className="">LOGOUT</button>
                    </Link>
                  </div>
                </>
              )}
              {/* <LoginBtn>
                <Link to="/login">Login</Link>
              </LoginBtn>
              <LoginBtn>
                <Link to="/register">Register</Link>
              </LoginBtn> */}
            </Buttons>
            <Nav className="mobile">
              <Link to="/">Home</Link>
              <Link to="/about-us">About Us</Link>
              <Link to="/blog">Blogs</Link>
              <Link to="/contact-us">Contact Us</Link>
            </Nav>
            <P>Copyright</P>
          </Slider>
          <MobileHeaderBottom>
            <div className="w-full flex justify-between items-center px-2">
              <Link to="/" className="flex flex-col items-center justify-center flex-1 py-1 text-kerala-green hover:text-kerala-gold transition-colors">
                <GoHome style={{ fontSize: "24px" }} />
                <span className="text-[10px] font-semibold font-jost mt-1 uppercase tracking-wider">Home</span>
              </Link>
              <button onClick={handleOpenCategory} className="flex flex-col items-center justify-center flex-1 py-1 text-kerala-green hover:text-kerala-gold transition-colors border-none bg-transparent outline-none">
                <MdOutlineCategory style={{ fontSize: "24px" }} />
                <span className="text-[10px] font-semibold font-jost mt-1 uppercase tracking-wider">Categories</span>
              </button>
              <Link
                to={authenticated ? "/profile" : "#"}
                onClick={(e) => {
                  if (!authenticated) {
                    e.preventDefault();
                    setIsLogin(true);
                    const dlg = document.getElementById("dialog");
                    if (dlg && typeof dlg.showModal === "function") {
                      dlg.showModal();
                    }
                  }
                }}
                className="flex flex-col items-center justify-center flex-1 py-1 text-kerala-green hover:text-kerala-gold transition-colors"
              >
                <IoPersonOutline style={{ fontSize: "24px" }} />
                <span className="text-[10px] font-semibold font-jost mt-1 uppercase tracking-wider">Profile</span>
              </Link>
              <Link
                to={authenticated ? "/cart" : "#"}
                onClick={(e) => {
                  if (!authenticated) {
                    e.preventDefault();
                    setIsLogin(true);
                    const dlg = document.getElementById("dialog");
                    if (dlg && typeof dlg.showModal === "function") {
                      dlg.showModal();
                    }
                  }
                }}
                className="flex flex-col items-center justify-center flex-1 py-1 text-kerala-green hover:text-kerala-gold transition-colors relative"
              >
                {cartData && cartData.length > 0 && (
                  <span className="absolute top-0 right-4 bg-kerala-green text-white text-[9px] font-bold h-4 w-4 rounded-full flex items-center justify-center border border-white">
                    {cartData.length}
                  </span>
                )}
                <PiShoppingCartThin style={{ fontSize: "24px" }} />
                <span className="text-[10px] font-semibold font-jost mt-1 uppercase tracking-wider">Cart</span>
              </Link>
              <CategoriesModal className={isCategoriesVisible ? "active" : ""}>
                <Items className="mobile">
                  {data.slice(0, -1).map((item, i) => (
                    <Item
                      key={i}
                      onClick={() => {
                        handleCategoryMain(item.category_slug);
                      }}
                    >
                      <ItemDiv>
                        <>
                          <div>
                            <img
                              src={categoryurl + item.logo}
                              width={30}
                              height={30}
                            />{" "}
                          </div>
                          <div>{item.category_name}</div>
                        </>
                      </ItemDiv>
                    </Item>
                  ))}
                </Items>
              </CategoriesModal>
            </div>
          </MobileHeaderBottom>
          <MobileHeaderBottomBackground></MobileHeaderBottomBackground>
          <el-dialog>
            <dialog
              id="dialog"
              aria-labelledby="dialog-title"
              class="fixed inset-0 size-auto max-h-none max-w-none overflow-y-auto bg-transparent backdrop:bg-transparent lg:mt-0 mt-[40%] md:mt-[25%]"
            >
              <el-dialog-backdrop class="fixed inset-0 bg-[#62BC01] lg:bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"></el-dialog-backdrop>

              <div
                tabindex="0"
                class="flex min-h-[400px] lg:min-h-full items-end justify-center p-0 lg:p-4 text-center focus:outline-none sm:items-center sm:p-0 mt-0 md:mt-0 sm:mt-50"
              >
                <el-dialog-panel class="relative transform overflow-hidden lg:rounded-[54px] w-[100vw] lg:w-[max-content] rounded-[24px] bg-white text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 data-closed:sm:translate-y-0 data-closed:sm:scale-95">
                  {isLogin ? <Login /> : <Registration />}
                </el-dialog-panel>
                {/* </el-dialog-panel> */}
              </div>
            </dialog>
          </el-dialog>
        </>
      )}
    </>
  );
}

export default HeaderMainNew;
const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  @media screen and (max-width: 1080px) {
    display: none;
  }
`;
const Container = styled.div`
  display: grid;
  grid-template-columns: 0.2fr 1.8fr 0.5fr;
  gap: 20px;
  align-items: center;
`;
const Top = styled.div`
  padding: 16px 40px;
  background-color: #084c27;
  display: flex;
  align-items: center;
  justify-content: space-betnwee;
`;
const Left = styled.div``;
const Right = styled.div`
  a {
    background-color: #fff;
    color: #084c27;
    font-weight: 600;
    border-radius: 50px;
    padding: 10px 20px;
    font-size: 14px;
    font-family: "Jost", serif;
  }
`;
const Socials = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  a {
    flex-shrink: 0;

    background-color: #fff;

    border-radius: 50%;
    padding: 4px;
  }
  svg {
    color: #084c27;
    font-size: 15px;
  }

  /* mobile */
  &.mobile {
    justify-content: center;
    margin: 0 auto;
    a {
      background-color: transparent;
    }
    svg {
      font-size: 33px;
      padding: 5px;
      background-color: #084c27;
      color: #fff;
      border-radius: 10px;
    }
  }
`;
const Main = styled.div`
  background-color: #fff;
`;
const Section = styled.section`
  justify-self: end;
  /* .top-btns {
    @media screen and (max-width: 1080px) {
      display: none;
    }
  } */
`;
const ImageContainer = styled.div`
  height: 70px;
  width: 125px;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    display: block;
  }
  @media screen and (max-width: 540px) {
    height: 60px;
    width: 115px;
  }
`;
const Nav = styled.nav`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-self: center;
  justify-content: center;
  width: 100%;
  a {
    font-family: "Jost", serif;
    font-weight: 500;
    color: #000000;
    font-size: 18px;

    &:hover {
      transition: all 0.3s ease;
      font-size: 20px;
      font-weight: 500;
    }
  }

  /* mobile */
  &.mobile {
    display: grid;
    justify-content: start;
    a {
      width: 100%;
      margin-bottom: 10px;
      padding-bottom: 5px;
      /* border-bottom: 1px solid #9c9c9c; */
    }
  }
`;
const NavInner = styled.div`
  display: flex;
  gap: 35px;
  align-items: center;
  padding-left: 50px;

  a {
    font-family: "Jost", sans-serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0;

    @media (max-width: 1300px) {
      font-size: 15px;
    }
  }
`;
const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  background: #f3f3f3;
  padding: 5px 15px;
  margin-left: 20px;
  width: 35%;
  @media screen and (max-width: 1080px) {
    width: 100%;
  }
  @media screen and (max-width: 540px) {
    margin-left: 0px;
  }
`;
const SearchContainerOld = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #9c9c9c;
  border-radius: 7px;
  background: #f3f3f3;
  padding: 5px 15px;
  margin-left: 20px;
  width: 35%;
  @media screen and (max-width: 1080px) {
    width: 100%;
  }
  @media screen and (max-width: 540px) {
    margin-left: 0px;
  }
`;
const SearchSuggestions = styled.ul`
  position: absolute;
  top: 62%;
  z-index: 100;
  background-color: #084c27;
  left: 64%;
  transform: translateX(-50%);
  border-radius: 10px;
  &.mobile {
    @media screen and (max-width: 1080px) {
      top: calc(100% + 4px);
      left: 0;
      width: 100%;
      min-width: 100%;
      max-width: 100%;
      border-radius: 12px;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      transform: none;
    }
  }
  &.mobile-drop {
    top: 103%;
    left: 50%;
    width: 100%;
    max-height: 300px;
  }

  max-height: 350px;
  overflow-y: scroll;
`;
const Suggestion = styled.li`
  margin-left: 0;
  border-radius: 10px;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
  padding: 10px;
  &:hover {
    color: #fc9800;
  }
`;
const Input = styled.input`
  border: none;
  font-family: "Jost", serif;
  background: #f3f3f3;
  outline: none;
  &::placeholder {
    color: #9c9c9c;
    font-family: "Jost", serif;
  }
  &:focus {
    outline: none;
    border: none;
  }
  &.mobile-search {
    padding: 0;
    &::placeholder {
      padding-left: 0;
      padding-bottom: 0;
    }
  }
`;
const Buttons = styled.div`
  display: flex;
  align-items: end;
  gap: 25px;

  &.mobile {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: center;
    margin: 40px 0;
    button {
      padding: 8px 20px;
      border: 2px solid #084c27;
      border-radius: 8px;
      background-color: transparent;
    }
  }

  &.bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;
const LoginBtn = styled.button`
  border: 2px solid #084c27;
  border-radius: 5px;
  color: #084c27;
  padding: 5px 20px;
  background-color: transparent;
  font-family: "Jost", serif;
  font-size: 18px;
`;
const Button = styled.button`
  display: grid;
  justify-items: start;
  flex-shrink: 0;
  border: none;
  outline: none;
  background-color: transparent;
  a {
    font-family: "Jost", serif;
    color: #000;
    &:hover {
      transition: all 0.3s ease;
      font-size: 16px;
      font-weight: 500;
    }
  }
  svg {
    font-size: 20px;
  }

  &.notification-style {
    position: relative;
  }
  &.user {
    display: flex;
    align-items: center;
    /* justify-items: center;
    font-size: 13px; */
  }

  /* mobile */
  &.mobile {
    position: relative;
  }
`;
const Number = styled.p`
  height: 22px;
  width: 22px;
  border-radius: 50%;
  background-color: #ff0000;
  color: #fff;
  font-weight: 400;
  font-size: 13px;
  font-family: "Jost", serif;
  display: grid;
  place-items: center;
  position: absolute;
  left: -10px;
  top: -10px;
  margin-bottom: 0;
  /* mobile */
  &.mobile {
    position: absolute;
    right: -10px;
    top: -10px;
    height: unset;
    width: unset;
    height: 22px;
    width: 22px;
    font-size: 13px;
    margin-bottom: 0;
  }
`;
// mobile

const MobileHeader = styled.div`
  display: none;
  @media screen and (max-width: 1080px) {
    background-color: rgba(253, 251, 247, 0.96);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border-bottom: 1px solid rgba(197, 168, 128, 0.12);
    padding: 10px 20px;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
  }
  @media screen and (max-width: 540px) {
    padding: 12px 16px;
    gap: 10px;
  }
`;
const MobileHeaderBottom = styled.div`
  display: none;
  @media screen and (max-width: 1080px) {
    background-color: rgba(253, 251, 247, 0.96);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 15px;
    left: 0;
    right: 0;
    z-index: 1000;
    border: 1px solid rgba(197, 168, 128, 0.3);
    border-radius: 35px;
    justify-self: center;
    width: 90%;
    margin: 0 auto;
    box-shadow: 0 8px 24px rgba(18, 53, 36, 0.08);
  }
`;

const MobileHeaderSearch = styled.div`
  display: none;
  @media screen and (max-width: 1080px) {
    background-color: #FDFBF7;
    padding: 10px 20px;
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    position: fixed;
    top: 82px; /* Align with MobileHeader height */
    left: 0;
    width: 100%;
    z-index: 999;
    border-bottom: 1px solid rgba(197, 168, 128, 0.1);
  }
  @media screen and (max-width: 540px) {
    padding: 10px 16px;
    top: 79px; /* Align perfectly on smaller screens */
  }
`;
const MobileHeaderBottomBackground = styled.div`
  display: none !important;
`;
const Slider = styled.div`
  position: fixed;
  left: -100%;
  top: 0;
  padding: 10px 20px;
  height: 100%;
  background-color: #f8f8f8;
  transition: all 0.5s linear;
  z-index: 11;
  &.active {
    left: 0;
  }
`;
const MobileTop = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.1fr;
  gap: 20px;
  align-items: center;

  svg {
    font-size: 20px;
    background-color: #d5dded;
    padding: 5px;
    border-radius: 50%;
  }
`;
const P = styled.p`
  font-family: "Jost", serif;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`;
const ItemContainer = styled.div`
  padding: 10px 0;
  background-color: #f4f4f4;
`;
const Items = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  &.mobile {
    flex-direction: column;
  }
`;
const Dropdown = styled.div`
  z-index: 99;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(100% - 0px);
  border-radius: 10px;

  box-shadow: 1px 1px 14px #4242426f;
  background-color: #fff;
  padding: 10px;

  transition: all 0.3s ease;
  display: none;
  /* opacity: 0; */

  li {
    font-size: 15px;
    color: #000;
    min-width: max-content;
    list-style-type: none;
    padding: 8px 10px;
    cursor: pointer;
    &:hover {
      color: #fc9800;
    }
  }
`;
const Item = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  transform: all 0.5s ease;

  &:hover ${Dropdown} {
    display: grid;
    /* opacity: 1; */
  }
`;
const Icon = styled.div``;
const Text = styled.p`
  font-size: 16px;
  color: #000;
  font-family: "Jost", serif;
`;
const Arrow = styled.div`
  svg {
    font-size: 16px;
    color: #000;
  }
`;
const LoginButton = styled.div`
  font-size: 20px;
  text-transform: capitalize;
`;
const ItemDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
const LogoutModal = styled.div`
  position: absolute;
  right: 75px;
  top: 72px;
  z-index: 1;
  display: ${(props) => (props.open ? "block" : "none")};
`;

const LogoutModalMobileSec = styled.div`
  position: absolute;
  right: 20px;
  top: 147px;
  z-index: 20;
  display: ${(props) => (props.open ? "block" : "none")};
`;

const LogoutModalMobile = styled.div`
  position: absolute;
  right: -100%;
  bottom: 62px;
  z-index: 2;
  background-color: #fff;
  padding: 10px;
  transition: 0.3s ease;
  &.active {
    right: 0px;
  }

  button {
    margin-bottom: 0;
  }
  display: grid;
  gap: 20px;
`;
const CategoriesModal = styled.div`
  position: absolute;
  bottom: -800%;
  left: 0;
  width: 100%;
  padding: 20px;
  background-color: #fff;
  transition: all 0.4s ease;
  &.active {
    bottom: 62px;
  }
`;
const DropSearch = styled.div`
  display: none;
  @media screen and (max-width: 540px) {
    display: block;
    justify-self: end;
  }
`;
const MobileSearch = styled.div`
  @media screen and (max-width: 540px) {
    border-radius: 10px;
    background-color: #fff;
    justify-self: end;
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const MobileLoginButton = styled.span`
  font-family: "Jost", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #123524;
  border: 1px solid rgba(18, 53, 36, 0.15);
  border-radius: 20px;
  padding: 5px 12px;
  background-color: rgba(18, 53, 36, 0.03);
  transition: all 0.2s ease;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background-color: #123524;
    color: #fff;
    border-color: #123524;
  }
`;
